<template>
  <a-tabs
    class="hkl-tabs"
    :animated="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </a-tabs>
</template>

<script>

/**
 * Modal for HKLand
 * @type {import('vue').Component}
 * Support the props of follow link except @edit event
 * https://1x.antdv.com/components/tabs-cn/
 * @example
 * ```jsx
 * <HKLTabs defaultActiveKey="1" />
 * ```
 * @example
 * @description You have to manually handle switch tab logic
 * ```jsx
 * <HKLTabs :activeKey="[variable]" @change="(activeKey) => {}"/>
 * ```
 */

export default {
  model: {
    prop: 'activeKey',
    event: 'change',
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/_settings.scss';

.hkl-tabs {
  &.ant-tabs {
    color: $tender-font-color;
  }
  ::v-deep {
    // disabled prev and next buttons
    // https://github.com/vueComponent/ant-design-vue/blob/1.x/components/vc-tabs/src/ScrollableTabBarNode.jsx
    .ant-tabs-nav-container {
      transition: none;
    }
    .ant-tabs-nav-container-scrolling {
      padding-left: 0;
      padding-right: 0;
    }
    .ant-tabs-bar {
      border: none;
      margin-bottom: 20px;
    }
    .ant-tabs-nav {
      display: block;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: row wrap;
        flex-basis: 100%;
      }
    }
    .ant-tabs-tab {
      display: flex;
      justify-content: center;
      flex: 1 1 0;
      height: auto;
      padding: 5px 10px;
      margin-right: 1px;
      margin-left: 1px;
      color: #0C3A58;
      font-size: 20px;
      text-align: center;
      background-color: #ebebeb;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      &.ant-tabs-tab-active {
        background-color: #0C3A58;
        color: #ffffff;
      }
    }
    .ant-tabs-ink-bar {
      display: none !important;
    }
  }
}
.hkl-tabs.shadowline-theme {
  overflow: unset;
  ::v-deep {
    .ant-tabs-bar {
      margin-bottom: 0px;
    }
    .ant-tabs-nav-container {
      overflow: unset;
      margin-bottom: 0;
    }
    .ant-tabs-nav-wrap {
      overflow: unset;
      margin-bottom: 0;
    }
    .ant-tabs-nav-scroll {
      overflow: unset;
    }
    .ant-tabs-tab {
      color: $tender-font-color;
      font-size: 14px;
      font-weight: bold;
      box-shadow: 0 1px 5px rgba(128, 128, 128, 0.2);
      background-color: transparent;
      padding: 0;
      margin: 0;
      &.ant-tabs-tab-active {
        background-color: transparent;
        border-bottom: 5px solid #0C3A58
      }
    }
  }
}
</style>
